<template>
  <div>
    <ul class="rew19_clear rew19_receipt_lineup">
      <li class="rew19_wrapRadio_t1 lineup_full">
        <input
          v-model="e_transaction_type"
          id="receivingElectronicStatement1"
          class="rew19_fakeRadio_t1"
          type="radio"
          value="1"
          checked="checked"
        />
        <label for="receivingElectronicStatement1">제품 수령인만 수신</label>
      </li>

      <li class="rew19_wrapRadio_t1 lineup_full">
        <input
          v-model="e_transaction_type"
          id="receivingElectronicStatement2"
          class="rew19_fakeRadio_t1"
          type="radio"
          value="2"
        />
        <label for="receivingElectronicStatement2">제품 수령인 및 본인(회원정보 등록 연락처) 모두 수신</label>
      </li>
    </ul>
    <div class="rew19_clear rew19_indetailBt">
      <button type="button" class="rew19_btnDetail down">
        <span>자세히 보기</span>
      </button>
    </div>
    <div class="rew19_paymentDon" style="display:none">
        <span class="rew19_infoStar">전자거래명세서를 수신할 대상자를 선택할 수 있습니다.</span>
        <span class="rew19_infoStar">제품 수령인을 선택하면 배송 정보에 입력된 수령인 연락처로 전자 거래 명세서를 발송합니다.</span>
        <span class="rew19_infoStar">제품 수령인 및 본인을 선택하면 <b style="color: #C66FC0;">회원정보에 등록된 연락처와 배송 정보에 입력된 수령인 연락처 모두에게</b> 전자거래 명세서를 발송합니다.</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "ElectronicStatement",
  data() {
    return{
      e_transaction_type: "1"
    }
  },
  mounted() {
    let _this = this;
    _this.initUi();
  },
  methods: {
    initUi(){},
    getData(){
      let _this = this;

      return _this.e_transaction_type;
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/payment/ElectronicStatement.vue